import { useState, useMemo } from 'react';
import { Profile, Organization } from '@/types/directory';

interface UseDirectoryFiltersProps {
  profiles: Profile[];
  organizations: Organization[];
}

export const useDirectoryFilters = ({ profiles, organizations }: UseDirectoryFiltersProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedDirectoryCategory, setSelectedDirectoryCategory] = useState<string | null>(null);
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);
  const [selectedExperienceLevel, setSelectedExperienceLevel] = useState('all');
  const [selectedAvailability, setSelectedAvailability] = useState('all');
  const [showOrganizations, setShowOrganizations] = useState(false);

  const filteredProfiles = useMemo(() => {
    return profiles.filter(profile => {
      const matchesSearch = searchTerm === '' || 
        profile.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        profile.headline?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesCategory = selectedCategory === 'all' || profile.category_id === selectedCategory;
      
      return matchesSearch && matchesCategory;
    });
  }, [profiles, searchTerm, selectedCategory]);

  const filteredOrganizations = useMemo(() => {
    return organizations.filter(org => {
      const matchesSearch = searchTerm === '' ||
        org.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        org.description?.toLowerCase().includes(searchTerm.toLowerCase());

      return matchesSearch;
    });
  }, [organizations, searchTerm]);

  return {
    searchTerm,
    selectedCategory,
    selectedDirectoryCategory,
    selectedLanguages,
    selectedExperienceLevel,
    selectedAvailability,
    filteredProfiles,
    filteredOrganizations,
    setSearchTerm,
    setSelectedCategory,
    setSelectedDirectoryCategory,
    setSelectedLanguages,
    setSelectedExperienceLevel,
    setSelectedAvailability,
    showOrganizations,
    setShowOrganizations
  };
};